import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    imports: [FaIconComponent],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class LoaderComponent {
  @Input() embedded = false;
  @Input() message = '';
  faCheck = faCheck;
  faXmark = faXmark;
}
